import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IActivity} from "../../activities/activity";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getOngoingActivityState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ongoingActivity);

export const getOngoingActivity = createSelector(getOngoingActivityState,
  (state: IActivity): IActivity => state
);
